"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESOLVE_ORDER_MODAL = void 0;
var RESOLVE_ORDER_MODAL = {
  BUTTON__CANCEL: 'ordersResolveOrderModal-button-cancel',
  BUTTON__RESOLVE: 'ordersResolveOrderModal-button-resolve'
};
exports.RESOLVE_ORDER_MODAL = RESOLVE_ORDER_MODAL;